/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Open_To_JoinInputs */

const en_us2_clubs_open_to_join = /** @type {(inputs: Clubs_Open_To_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anyone who finds the club can join without a code.`)
};

const pt_br2_clubs_open_to_join = /** @type {(inputs: Clubs_Open_To_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qualquer pessoa que encontrar o clube pode entrar sem código.`)
};

const es_419_clubs_open_to_join = /** @type {(inputs: Clubs_Open_To_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cualquiera que encuentre el club puede unirse sin código.`)
};

const pt_pt2_clubs_open_to_join = /** @type {(inputs: Clubs_Open_To_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qualquer pessoa que encontre o clube pode entrar sem código.`)
};

const fr_fr2_clubs_open_to_join = /** @type {(inputs: Clubs_Open_To_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toute personne qui trouve le club peut le rejoindre sans code.`)
};

const de_de2_clubs_open_to_join = /** @type {(inputs: Clubs_Open_To_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wer den Club findet, kann ohne Code beitreten.`)
};

const it_it2_clubs_open_to_join = /** @type {(inputs: Clubs_Open_To_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiunque trovi il club può entrare senza codice.`)
};

/**
* | output |
* | --- |
* | "Anyone who finds the club can join without a code." |
*
* @param {Clubs_Open_To_JoinInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_open_to_join = /** @type {((inputs?: Clubs_Open_To_JoinInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Open_To_JoinInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_open_to_join(inputs)
	if (locale === "es-419") return es_419_clubs_open_to_join(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_open_to_join(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_open_to_join(inputs)
	if (locale === "de-DE") return de_de2_clubs_open_to_join(inputs)
	if (locale === "it-IT") return it_it2_clubs_open_to_join(inputs)
	return en_us2_clubs_open_to_join(inputs)
});
export { clubs_open_to_join as "clubs.open_to_join" }